import * as React from 'react';
import { Svg, Path } from 'react-native-svg';
import { memo } from 'react';
import type { IconProps } from '../helpers/icon-props';

const Icon = (props: IconProps) => {
  const { size = 24, ...otherProps } = props;
  return (
    <Svg width={size} height={size} viewBox="0 0 512 512" {...otherProps}>
      <Path
        d="M512 256c0 141.384-114.616 256-256 256S0 397.384 0 256C0 256.061 256 .028 256 0c141.384 0 256 114.616 256 256"
        fill="#d80027"
      />
      <Path
        d="M256 122.435v86.343l-89.043-86.343zM133.565 256h75.211l-75.211-100.174-11.13 77.913z"
        fill="#0052b4"
      />
      <Path d="M256 0h-.043zM255.315 256H256v-.685z" fill="#f0f0f0" />
      <Path
        d="M256 133.565V0h-.043C114.591.024 0 114.629 0 256h133.565v-75.211L208.776 256h46.54l.685-.685v-46.537l-75.213-75.213z"
        fill="#f0f0f0"
      />
      <Path
        d="M129.515 33.391a257.2 257.2 0 0 0-96.124 96.124V267.13h66.783V100.174H267.13V33.391z"
        fill="#d80027"
      />
      <Path
        d="M266.177 234.694 165.045 133.565h-31.48v.002l132.609 132.609h.002c.001.001.001-21.706.001-31.482"
        fill="#d80027"
      />
      <Path
        d="M289.391 133.565v122.434c0 59.64 155.826 59.64 155.826 0V133.565z"
        fill="#f3f3f3"
      />
      <Path
        d="M289.391 256v-.001c0 59.64 77.913 77.914 77.913 77.914s77.913-18.274 77.913-77.914V256z"
        fill="#6da544"
      />
      <Path
        d="m367.304 207.026-36.174 15.583V256l36.174 22.261L403.478 256v-33.391z"
        fill="#a2001d"
      />
      <Path d="M331.13 189.217h72.348v33.391H331.13z" fill="#338af3" />
    </Svg>
  );
};
Icon.displayName = 'Bermuda';
export const Bermuda = memo<IconProps>(Icon);
